<div class="container-fluid">
  <div class="row">
    <!-- <div
      class="col-xl-7 rounded-end-5"
      [ngStyle]="{
        'background-image': 'url(assets/images/login/login_splash.jpg)',
        'background-size': 'cover',
        'background-position': 'center center',
        display: 'block'
      }"
    >
      <img
        class="bg-img-cover bg-center d-none"
        src="assets/images/login/login_splash.jpg"
        alt="looginpage"
      />
    </div> -->
    <div class="col-xl-5 p-0" style="width: 100%;">
      <div class="login-card login-dark">
        <div>
          <div class="logo text-center">
            <img
              class="img-fluid for-light"
              src="assets/images/logo/logo.png"
              alt="looginpage"
              width="300"
            />
            <img
              class="img-fluid for-dark"
              src="assets/images/logo/logo_dark.png"
              alt="looginpage"
            />
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="form">
              <h4 class="innoku-color">{{ "PasswordReset.Title" | translate }}</h4>
              <div class="form-group">
                <label class="col-form-label">{{
                  "PasswordReset.Fileds.Email" | translate
                }}</label>
                <input
                  [ngClass]="[
                    'form-control',
                    !form.controls.email.touched
                      ? ''
                      : !form.controls.email?.errors
                      ? 'is-valid'
                      : 'is-invalid'
                  ]"
                  type="email"
                  formControlName="email"
                />
              </div>
              <div class="form-group mb-0">
                <div class="text-end mt-3">
                  <button
                    class="btn btn-primary-innoku d-block w-100"
                    [disabled]="!form.valid"
                    (click)="passwordReset()"
                    type="button"
                  >
                    <span
                      >{{ "PasswordReset.BtnSubmitLabel" | translate }}
                      <span
                        class="spinner-border spinner-border-sm"
                        *ngIf="loading"
                      ></span
                    ></span>
                  </button>
                </div>
              </div>
              <p class="mt-4 mb-0">
                {{ "PasswordReset.GoBackQuestion" | translate }}
                <a [routerLink]="'/auth/login'" class="ms-2 innoku-color">{{
                  "PasswordReset.GoBackLink" | translate
                }}</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
